import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "play-icon_a4d6d",
  "use": "play-icon_a4d6d-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"play-icon_a4d6d\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 7.5C0 11.625 3.375 15 7.5 15S15 11.625 15 7.5 11.625 0 7.5 0 0 3.375 0 7.5zm6 3.375L10.5 7.5 6 4.125v6.75zM1.5 7.5c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6z\" fill=\"inherit\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol